import { render, staticRenderFns } from "./list.vue?vue&type=template&id=addac6c6&scoped=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"
import style0 from "./list.vue?vue&type=style&index=0&id=addac6c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addac6c6",
  null
  
)

export default component.exports